import { replaceUnderLine } from '@/utils/Util';

export const handleValidateFields = (fields, setErrors, selectedStageTask) => {
	const newErrors = {};

	if (!fields?.taskName) {
		newErrors.taskName = 'Task name is required';
	}
	if (!fields.stage) {
		newErrors.stage = 'State is required';
	}
	if (!fields.taskPosition) {
		newErrors.taskPosition = 'Task position is required';
	}
	if (!fields.selectedTaskForPosition && selectedStageTask?.length > 0) {
		newErrors.selectedTaskForPosition = 'Task position is required';
	}
	if (!fields.compleationCondition) {
		newErrors.compleationCondition = 'Please select compleation condition';
	}
	if (!Array.isArray(fields?.whoCanCompleate) || fields.whoCanCompleate.length === 0) {
		newErrors.whoCanCompleate = 'Please select at least one user who can complete the task';
	}
	setErrors(newErrors);

	return Object.keys(newErrors)?.length > 0;
};

export const getFormattedUserList = (response = []) => {
	return response?.map((user) => ({
		...user,
		id: user,
		value: user,
		label: replaceUnderLine(user, true)
	}));
};

export const formatStageList = (stageList = []) => {
	return stageList?.map((item) => ({
		...item,
		id: item?.id,
		name: item?.name,
		value: item?.name
	}));
};

export const fromatRequiredIfConditions = (taskConditionList = []) => {
	return taskConditionList?.map((item) => ({
		...item,
		id: item?.constant,
		value: item?.constant,
		label: item.name
	}));
};

export const formatTaskList = (taskList) => {
	return taskList?.map((item) => ({
		...item,
		value: item?.name,
		label: item?.name
	}));
};

const findAfterTask = (id, taskList) => {
	const findTask = taskList?.findIndex((item) => item?.id === id);
	if (findTask !== -1) {
		if (taskList[findTask]?.isFirstTaskOfStage) {
			return {
				...taskList[findTask],
				value: taskList[findTask]?.taskValueType,
				name: taskList[findTask]?.name
			};
		} else {
			return {
				...taskList[findTask - 1],
				value: taskList[findTask - 1]?.taskValueType,
				name: taskList[findTask - 1]?.name
			};
		}
	}
};

export const formatSelectedTaskToEdit = (selectedTaskToEdit, taskList) => {
	const dependencyLogicType =
		selectedTaskToEdit?.dependencyLogicType?.constant || selectedTaskToEdit?.dependencyLogicType;

	// get mapping values in numeric key order when keys are numbers (handles keys like '1','2','10')
	const mappingEntries = Object.entries(selectedTaskToEdit?.journeyMappingTypeMap || {}).sort((a, b) => {
		const ak = Number(a[0]);
		const bk = Number(b[0]);
		if (Number.isNaN(ak) || Number.isNaN(bk)) {
			return String(a[0]).localeCompare(String(b[0]));
		}
		return ak - bk;
	});
	const mappingValues = mappingEntries.map(([, v]) => v);
	const result = {
		...selectedTaskToEdit,
		id: selectedTaskToEdit?.id,
		taskName: selectedTaskToEdit?.name,
		stage: {
			...selectedTaskToEdit?.productDevelopmentStageResponse,
			value: selectedTaskToEdit?.productDevelopmentStageResponse?.name,
			label: selectedTaskToEdit?.productDevelopmentStageResponse?.name
		},
		taskPosition: selectedTaskToEdit?.isFirstTaskOfStage
			? { id: 'FIRST_TASK', value: '1st task' }
			: { id: 'AFTER', value: 'After' },
		selectedTaskForPosition: findAfterTask(selectedTaskToEdit?.id, taskList),
		compleationCondition: {
			value: selectedTaskToEdit?.taskValueType?.constant,
			id: selectedTaskToEdit?.taskValueType?.constant,
			name: selectedTaskToEdit?.taskValueType?.name
		},
		dependency:
			selectedTaskToEdit?.dependentTaskList?.map((item) => ({
				...item,
				id: item?.id,
				value: item?.name,
				label: item?.name
			})) || [],
		whoCanCompleate:
			selectedTaskToEdit?.userTypeResponseList?.map((user) => ({
				...user,
				id: user?.constant,
				value: user?.constant,
				label: user?.name
			})) || [],
		requiredCondition:
			selectedTaskToEdit?.taskNotRequiredConditionList?.map((item) => ({
				id: item,
				value: item,
				label: item
			})) || [],
		taskStatus: {
			id: selectedTaskToEdit?.status,
			value: selectedTaskToEdit?.status,
			label: selectedTaskToEdit?.status
		},
		dependencyToggle: dependencyLogicType === 'OR'
	};

	// Add journey mapping fields as an array
	result.journeys = mappingValues.map((mappingValue) => ({
		journeyType: {
			value: mappingValue?.journeyMappingType?.constant,
			id: mappingValue?.journeyMappingType?.constant,
			name: mappingValue?.journeyMappingType?.name
		},
		journey: {
			value: mappingValue?.journey?.name,
			id: mappingValue?.journey?.id,
			name: mappingValue?.journey?.name
		}
	}));

	// Set individual journey fields for first 3 journeys (for backward compatibility)
	if (mappingValues.length > 0) {
		result.journeyTypeOne = {
			value: mappingValues[0]?.journeyMappingType?.constant,
			id: mappingValues[0]?.journeyMappingType?.constant,
			name: mappingValues[0]?.journeyMappingType?.name
		};
		result.journeyOne = {
			value: mappingValues[0]?.journey?.name,
			id: mappingValues[0]?.journey?.id,
			name: mappingValues[0]?.journey?.name
		};
	}
	if (mappingValues.length > 1) {
		result.journeyTypeTwo = {
			value: mappingValues[1]?.journeyMappingType?.constant,
			id: mappingValues[1]?.journeyMappingType?.constant,
			name: mappingValues[1]?.journeyMappingType?.name
		};
		result.journeyTwo = {
			value: mappingValues[1]?.journey?.name,
			id: mappingValues[1]?.journey?.id,
			name: mappingValues[1]?.journey?.name
		};
	}
	if (mappingValues.length > 2) {
		result.journeyTypeThree = {
			value: mappingValues[2]?.journeyMappingType?.constant,
			id: mappingValues[2]?.journeyMappingType?.constant,
			name: mappingValues[2]?.journeyMappingType?.name
		};
		result.journeyThree = {
			value: mappingValues[2]?.journey?.name,
			id: mappingValues[2]?.journey?.id,
			name: mappingValues[2]?.journey?.name
		};
	}

	return result;
};
